import { useState } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const langKey = suffix => `editor.form.properties.${suffix}`;
const CreateNewFieldHint = ({
  onClose = () => {},
  toggleToCreateTab = () => {}
}) => {
  const [showAlert, setShowAlert] = useState(true);
  const handleOnClose = () => {
    setShowAlert(false);
    onClose();
  };
  if (!showAlert) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "tip",
    use: "inline",
    closeable: true,
    onClose: handleOnClose,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey('dontSeeHint')
    }),
    children: /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: toggleToCreateTab,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.form.properties.createNewHint"
      })
    })
  });
};
export default CreateNewFieldHint;